module.exports = __webpack_public_path__ + "images/markers-soft@2x_ad459aeb4ab160be9949504c2b36023d.png";